import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import {
	autoEuropePricingIdIsSubmitting,
	autoEuropePricingIdListData,
	clearAutoEuropePricingIdSignals,
} from "Pages/AutoEuropeTool/PricingId/@signals"

const PRICING_ID_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/pricing-id`

const extractId = o => (typeof o === 'object' && o !== null) ? o.value : o
const extractIds = arr => (arr ?? []).map(extractId)

const transformData = (data) => ({
	offices: extractIds(data.offices),
	market: data.market ? extractId(data.market) : null,
	pricingRecordId: Number(data.pricingRecordId),
	autoeuropeVsMetaId: data.autoeuropeVsMetaId ? Number(data.autoeuropeVsMetaId) : null,
	cr8VsMetaId: data.cr8VsMetaId ? Number(data.cr8VsMetaId) : null,
})

export default function useAutoEuropePricingIdFormSubmit({ getTableData }) {
	const { showToast } = useToast()

	const onSubmit = useCallback((data) => {
		autoEuropePricingIdIsSubmitting.value = true
		const isEditing = !!data._isEditing
		const endpoint = isEditing ? 'edit' : 'create'

		postSubmit(`${PRICING_ID_API}/${endpoint}`, transformData(data))
			.then(() => {
				autoEuropePricingIdIsSubmitting.value = false
				getTableData()
				clearAutoEuropePricingIdSignals()
				showToast.success(isEditing ? "Pricing ID updated" : "Pricing ID created")
			})
			.catch(async (e) => {
				autoEuropePricingIdIsSubmitting.value = false
				if (e?.status === 409) {
					const body = await e.json().catch(() => ({}))
					showToast.error(body?.error_msg || "Pricing Record ID already exists", { autoClose: 20000 })
				} else {
					showToast.error("Error saving Pricing ID record", { autoClose: 20000 })
				}
			})
	}, [getTableData])

	return { onSubmit }
}